var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-slide-x-transition',{attrs:{"mode":"out-in","appear":""}},[_c('LookUpMain',{attrs:{"Header":_vm.Header},on:{"GetHeaders":_vm.GetHeaders}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }